module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-lookup",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete"])) { return null; }
        return _vm.deletevalue($event)
      }
    }
  }, [_c('el-input', {
    attrs: {
      "readonly": "",
      "disabled": _vm.disabled,
      "icon": "search",
      "on-icon-click": _vm.showLookupDialog
    },
    model: {
      value: (_vm.lookupValue.name),
      callback: function($$v) {
        _vm.$set(_vm.lookupValue, "name", $$v)
      },
      expression: "lookupValue.name"
    }
  }), _vm._v(" "), _c('rt-lookup-dialog', {
    ref: "lookupDialog",
    attrs: {
      "isMaskShow": _vm.isMaskShow,
      "entity": _vm.entity,
      "condition": _vm.condition,
      "request-url": _vm.dialogRequestUrl,
      "name-field": _vm.nameField,
      "id-field": _vm.idField,
      "display-fields": _vm.dialogDisplayFields,
      "orderby-fields": _vm.dialogOrderbyFields,
      "filter-fields": _vm.dialogFilterFields
    },
    on: {
      "data-selected": _vm.handleDataSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37746546"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/lookup/src/lookup.vue
// module id = 682
// module chunks = 220